export default function CTASection() {
  return (
    <section className="relative bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="lg:w-1/2 relative min-h-[320px] lg:min-h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20luxury%20leather%20tote%20bag%20and%20silk%20scarf%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%20casting%20gentle%20shadows%2C%20editorial%20style%2C%20neutral%20warm%20beige%20and%20cream%20tones%2C%20clean%20aesthetic%2C%20no%20text&width=960&height=1200&seq=cta-left-unique-2026b&orientation=portrait"
            alt="Premium sourcing products"
            className="w-full h-full object-cover object-top absolute inset-0"
          />
          <div className="absolute top-6 left-6">
            <span className="px-4 py-1.5 bg-background-50/80 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full">
              New Arrival
            </span>
          </div>
          <div className="absolute bottom-10 left-6 right-6">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
              Start Sourcing<br />
              Winning Products<br />
              Today
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 flex items-center justify-center bg-background-50 py-16 px-8 md:px-16">
          <div className="text-center max-w-md">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-6 leading-tight">
              Get<br />
              AllChinaBuy<br />
              Spreadsheet
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-10">
              Get access to structured China product intelligence and start finding winning products faster. Everything you need in one powerful spreadsheet system.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-10 py-4 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}